<template>
  <div class="btn">
    <button @click="handleSubmit">{{point}} {{priceUnit}} 立即充值</button>
  </div>
</template>

<script>
import api from "../../api";
import store from '../../api/store'


export default {
  props: ["point", "disabled", "phone", "id", "faceValue"],
  data(){
    return {
      priceUnit: store.loginedUser.config.pointName
    }
  },
  methods: {
    handleSubmit() {
      console.log(this.disabled);
      if (this.disabled) {
        if (this.point) {
          let content = `使用${this.point}${this.priceUnit}充值${this.faceValue}元话费？`;
          this.$confirmDialog(content, btn => {
            if (btn == "确定") {
              this.$showLoading("充值中...");

              api.charge.handleCharge(
                this.phone,
                this.point,
                this.id,
                res => {
                  this.$hideLoading();
                  this.$confirmDialogWithOpts(
                    "交易完成",
                    "success",
                    ["查看订单", "继续充值"],
                    btn => {
                      if (btn == "查看订单") {
                        this.$routerPush(this, "/pages/charge/List");
                      } else if (btn == "继续充值") {
                      }
                    }
                  );
                },
                r => {
                  this.$alertDialog(r.msg);
                  this.$hideLoading();
                }
              );
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.btn {
  display: flex;
  justify-content: center;
  padding-bottom: 10.66vw;
  button {
    width: 84.54vw;
    background: linear-gradient(to right, #ff3542, #ff5d3e);
    color: #fff;
    border: 0;
    outline: none;
    padding: 2.66vw 0;
    border-radius: 5px;
    font-size: 4vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/charge/ButtonPanel.vue